import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectivePreloadStrategy implements PreloadingStrategy {
  private signInPreloadActive = false;

  enableSignInPreload(): void {
    this.signInPreloadActive = true;
  }

  disableSignInPreload(): void {
    this.signInPreloadActive = false;
  }

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload']) {
      return load();
    }
    if (route.data?.['preloadFromSignIn'] && this.signInPreloadActive) {
      return load();
    }
    return of(null);
  }
}
